export default __webpack_public_path__ + "static/media/strawberry.a3e67a77.jpg";